(function () {
  'use strict'

  require('dynamic-bind-html')

  require('./scss/app.scss')
  require('./scss/app-vcard-image-promo.scss')

  var MODULE_NAME = 'thismoment.card.component.appVcardImagePromo'
  var templateUrl = require('./tpl/app-vcard-image-promo.html')

  require('angular')
    .module(MODULE_NAME, [
      'dynamicBindHtml'
    ])
    .config(appVcardImagePromoConfig)
    .component('thismomentAppVcardImagePromo', {
      require: {
        parent: '^thismomentCard'
      },
      bindings: {
        item: '<'
      },
      templateUrl: templateUrl,
      controller: appVcardImagePromoController
    })

  appVcardImagePromoConfig.$inject = ['$compileProvider']
  function appVcardImagePromoConfig ($compileProvider) {
    $compileProvider.aHrefSanitizationWhitelist(/^\s*(https?|mailto|tel|sms):/)
  }

  appVcardImagePromoController.$inject = []
  function appVcardImagePromoController () {
    var vm = this

    vm.$onInit = vcardImagePromoInit

    function vcardImagePromoInit () {
      vm.trackEvent = vm.parent.trackEvent

      if (vm.item.app.contact_method === 'email') {
        vm.vcardImagePromoLink = 'mailto:' + vm.item.app.user.vcard.email
        vm.vcardLinkTarget = '_self'
        vm.eventTriggerDetail = ''
        vm.eventTrigger = 'contacted-email'
      } else if (vm.item.app.contact_method === 'phone') {
        vm.vcardImagePromoLink = 'tel:' + vm.item.app.user.vcard.phone_selected
        vm.vcardLinkTarget = '_self'
        vm.eventTriggerDetail = ''
        vm.eventTrigger = 'contacted-phone'
      } else {
        vm.vcardImagePromoLink = vm.item.app.user.vcard.website
        vm.vcardLinkTarget = '_blank'
        vm.eventTriggerDetail = vm.item.app.user.vcard.website
        vm.eventTrigger = 'clicked-learn-more'
      }
    }
  }

  module.exports = MODULE_NAME
})()



// WEBPACK FOOTER //
// ./src/card/component/app-vcardImagePromo.js